import { reactEvents } from '../../bridge/reactEvents';

// @ngInject
const setupBridgeEvents = (
  AuthService,
  ExportArticleExcelDialogService,
  $state,
  $window,
) => {
  reactEvents.excelExportClicked.subscribe((exportArticleEvent) => {
    AuthService.getUser().then((u) => {
      ExportArticleExcelDialogService.showDialog({
        selectedArticles: exportArticleEvent.articles,
        branchIds: exportArticleEvent.branchIds,
        organization: { id: u.organizationId },
        hideBranchIds: exportArticleEvent.hideBranchIds,
        selectedTemplate: exportArticleEvent.template,
      });
    });
  });

  reactEvents.routingChanged.subscribe((path) => {
    if (path.newTab) {
      const url = $state.href(path.to, path.navObj);
      $window.open(url, '_blank');
    } else {
      $state.go(path.to, path.navObj, path.options);
    }
  });
};

angular.module('app.bridgeEvents', []).run(setupBridgeEvents);
